import { Alert, AlertTitle } from "@mui/material";
import { useLocation } from "react-router-dom";
import Centered from "./centralComponents/Centered";

export default function NotFoundPage() {
    const location = useLocation();
    return (
        <Centered>
            <Alert severity="error">
                <>
                    <AlertTitle>Error</AlertTitle>
                    {`No page for this url: `}
                    <b>{location.pathname}</b>
                </>
            </Alert>
        </Centered>
    );
}